type VersionPayload = {
  version?: unknown;
};

const RECOVERY_KEY_PREFIX = "ui-chunk-recovery:";

const CHUNK_ERROR_PATTERNS = [
  /loading (css )?chunk \S+ failed/i,
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /unable to preload css/i
];

const recoveryKey = (version: string) => `${RECOVERY_KEY_PREFIX}${version}`;

export const isChunkLoadError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;

  const { name, message } = error as { name?: unknown; message?: unknown };
  if (name === "ChunkLoadError") return true;
  if (typeof message !== "string") return false;

  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};

export const reloadDocument = (): void => {
  window.location.reload();
};

export const hasRecoveryAttempt = (version: string): boolean => {
  try {
    return window.sessionStorage.getItem(recoveryKey(version)) !== null;
  } catch {
    return false;
  }
};

export const markRecoveryAttempt = (version: string): boolean => {
  try {
    window.sessionStorage.setItem(recoveryKey(version), "1");
    return true;
  } catch {
    return false;
  }
};

export const clearRecoveryAttempt = (version: string): void => {
  try {
    window.sessionStorage.removeItem(recoveryKey(version));
  } catch {
    /* A session without usable storage cannot hold a stale recovery flag. */
  }
};

export const fetchLatestVersion = async (): Promise<string | null> => {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store"
    });

    if (!response.ok) return null;

    const payload = (await response.json()) as VersionPayload;
    return typeof payload.version === "string" && payload.version.length > 0
      ? payload.version
      : null;
  } catch {
    return null;
  }
};
